<template>
    <Toast />
    <ConfirmDialog group="dialog" />
    <div class="p-grid">
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Recruiters.view.Label') }}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.Company Name') }}:</label>
                    <div class="p-col-12 p-md-10">{{ company_name == null ? 'N/A' : company_name }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.Incharge') }}:</label>
                    <div class="p-col-12 p-md-10">{{ in_charge == null ? 'N/A' : in_charge }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.Industry') }}:</label>
                    <div class="p-col-12 p-md-10">{{ industry_name == null ? 'N/A' : industry_name }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.Email') }}:</label>
                    <div class="p-col-12 p-md-10">{{ email }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.Phone') }}:</label>
                    <div class="p-col-12 p-md-10">{{ formatPhoneNumber(phone_number) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.Address') }}:</label>
                    <div class="p-col-12 p-md-10">{{ company_address == null ? 'N/A' : company_address }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.DetailAddress') }}:</label>
                    <div class="p-col-12 p-md-10">{{ c_detail_address == null || c_detail_address == 'null' ? 'N/A' : c_detail_address }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.Access') }}:</label>
                    <div class="p-col-12 p-md-10">{{ access_times == "" ? 'N/A' : access_times }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.Lastlog') }}:</label>
                    <div class="p-col-12 p-md-10">{{ last_login == "" ? 'N/A' : FormatDate(last_login) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Recruiters.view.Note') }}:</label>
                    <div class="p-col-12 p-md-12" :style="error?.note ? 'border: 1px solid red' : ''">
                        <Textarea :placeholder="$t('Recruiters.view.Desc')" :autoResize="true" rows="5" cols="30"
                            v-model="note" style="width: 97%; margin-left: 0px; margin-top: 14px"
                            @keydown.space="preventLeadingSpace" />
                    </div>
                    <div class="text-red">{{ error.note }}</div>
                </div>
                <div class="p-d-flex">
                    <Button @click="UpdateRecruiter()" :label="$t('JobSeekers.view.Save')"
                        class="p-button-outlined p-mr-2 p-mb-2" id="Save" icon="pi pi-check" iconPos="left"></Button>
                </div>
                <div class="p-col-12">
                    <!-- <div class="p-d-flex p-jc-between"> -->
                    <div style="margin-left:-14px; float: left;margin-top: -10px" class="p-d-flex p-jc-end p-ai-center"
                        v-if="type == 'admin'">
                        <Button @click="del($route.params.id)" :label="$t('Recruiters.view.Delete')"
                            class="p-button-outlined p-button p-mr-2 p-mb-2" icon="pi pi-trash" iconPos="left"
                            :disabled="type == 'super_admin' ? false : true" id="disable"></Button>
                    </div>
                    <div style="margin-left:-14px; float: left;margin-top: -10px" class="p-d-flex p-jc-end p-ai-center"
                        v-else>
                        <Button @click="del($route.params.id)" :label="$t('Recruiters.view.Delete')"
                            class="p-button-outlined p-button-danger p-mr-2 p-mb-2" icon="pi pi-trash"
                            iconPos="left"></Button>
                    </div>
                    <div class="p-d-flex p-jc-end p-ai-center"
                        style="float: right;margin-top: -10px; margin-right: 16px;">
                        <Button @click="$router.go(-1)" icon="pi pi-replay" iconPos="left"
                            :label="$t('Recruiters.view.Back')" class="p-button p-button-outlined p-mr-2 p-mb-2" style="background: white; color: black;"/>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
// import ProductCategoryService from '../../../service/API/ProductCategoryService';
import RecruiterService from '../../../service/API/RecruiterService';
// import {useRouter} from 'vue-router'
// import validateRecruiterNote from '../../../validations/Recruiter/validateRecruiterNote';
import moment from 'moment';
export default {
    data() {
        return {
            disInq: true,
            renderTxt: false,
            replied: false,
            replyText: '',
            replyStatus: 'answered',
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {},
            access_times: '',
            company_address: '',
            company_name: '',
            company_postal_code: '',
            email: '',
            id: '',
            in_charge: '',
            industry: '',
            last_login: '',
            note: '',
            phone_number: '',
            industry_name: '',
            c_detail_address:'',
            type: localStorage.getItem('admin-type'),
            error: {}
        };
    },
    created() {
        this.recruiterService = new RecruiterService();
    },
    methods: {
        del(id) {
            var self = this;
            self.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: '취소',
                accept: () => {
                    axios({ method: 'post', url: `api/v1/admin/user/delete/`, data: { id: id } }).then((res) => {
                        console.warn(res);
                        self.$router.push({ name: 'Recruiter' });
                        setTimeout(() => {
                            self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                        }, 500);

                    });


                },
                // reject: () => {
                //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                // },
            });
        },
        formatPhoneNumber(num) {
            var cleaned = ('' + num).replace(/\D/g, '');
            if (num.toString().length == '11') {
                var match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
                if (match) {
                    return '(' + match[1] + ') ' + match[2] + ' - ' + match[3];
                }
                return null;
            }
            else if (num.toString().length == '10') {
                var match1 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
                if (match1) {
                    return '(' + match1[1] + ') ' + match1[2] + ' - ' + match1[3];
                }
                return null;
            }
            else if (num.toString().length == '9') {
                var match2 = cleaned.match(/^(\d{1})(\d{4})(\d{4})$/);
                if (match2) {
                    return '(' + match2[1] + ') ' + match2[2] + ' - ' + match2[3];
                }
                return null;
            }


        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, "");
        },
        FormatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY.MM.DD - h:mm:ss');
            }
        },
        UpdateRecruiter() {
            // let vcheckData = {
            //     note: this.note,
            //     // type: this.dropdownValueType == null ? '' : 'something',
            // };
            // const { isInvalid, error } = validateRecruiterNote(vcheckData);
            // if (isInvalid) {
            //     this.error = error;
            //     console.log(error);
            // } else {
            // console.log(this.formData);
            return axios
                .post('api/v1/admin/job-recruiter/note-update/', { id: this.$route.params.id, note: this.note })
                .then(() => {
                    // alert('성공적으로 저장');
                    // this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Succesfully Published.', life: 3000 });
                    this.$router.push({ name: 'Recruiter' });
                    setTimeout(() => {
                        this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '메모가 저장되었습니다.', life: 3000 });
                    }, 500);
                });
        }
        // },
    },
    mounted() {
        this.recruiterService.viewRecruiter(this.$route.params.id).then((result) => {
            console.log(result);
            this.company_name = result[0].company_name;
            this.email = result[0].email;
            this.name = result[0].name;
            this.industry_name = result[0].industry_name;
            this.phone_number = result[0].phone_number;
            this.company_address = result[0].company_address;
            this.last_login = result[0].last_login;
            this.note = result[0].note;
            this.in_charge = result[0].in_charge;
            this.access_times = result[0].access_times;
            this.c_detail_address = result[0].c_detail_address;
            // this.status = data.status;
            // this.mydata = data;
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

button#Save {
    background: black;
    color: white;
}

.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}

button#disable {
    background: grey;
    color: white;
}
</style>